export const PATH = {
  login: "/login",

  emailLogin: "/login/email",
  pcLogin: "/pc/login",
  coachLogin: "/coach",
  applock: "/applock",
  applockSetup: "/applock-setup",
  redirect: "/oauth/kakao",
  redirect_apple: "/oauth/apple",
  onboarding: "/onboarding/:id",
  onboarding_new: "/onboarding_new/:type/:id",
  refund: "/refund",
  etc_where: "/onboarding_new/etc_where",
  recommend_who: "/onboarding_new/recommend_who",
  influencer_who: "/onboarding_new/influencer_who",

  home: "/:taskKey?",
  payment: "/payment",
  planUpgrade: "/plan-upgrade",

  commitment: "/commitment",

  tossPayments: "/toss-payments",
  tossPaymentsPlanUpgrade: "/toss-payments/plan-upgrade",
  tossPaymentsSuccess: "/toss-payments/success",
  tossPaymentsPlanUpgradeSuccess: "/toss-payments/plan-upgrade/success",
  tossPaymentsFail: "/toss-payments/fail",
  tossPaymentsPlanUpgradeFail: "/toss-payments/plan-upgrade/fail",

  newsletterSettings: "/newsletter/settings",

  selfCheck: "/self-check/:tool/:id",
  selfCheckEnd: "/self-check/:tool/end",

  emailAuthResult: "email-auth/result",

  meditationTool: "/meditation",
  guide: "/guide/:id",
  promotionBook: "/promotion/:type",
  account: "/mypage/account",
  support: "/support/faq",
  supportDetail: "/support/faq/detail",
  promotionPhoneNumberSubmit: "/benefit-apply",
  test: "/test",

  privacyPolicy: "/privacy-policy",
  termsOfService: "/terms-of-service",

  promotionOnboarding: "/promotion-onboarding/:type/:id",
  promotionLogin: "/promotion-login",
  promotion_redirect_apple: "/promotion/oauth/apple",
  promotionTosspaymentsSuccess: "/promotion-tosspayments/success",
  promotionTosspaymentsFail: "/promotion-tosspayments/fail",
  promotionCompleted: "/promotion-completed",
  promotionAlreadyUsed: "/promotion-already-used",

  v3Product: "/v3-product",
  v3Login: "/v3-login",
  v3_redirect_apple: "/v3/oauth/apple",
  v3NicknameSubmit: "/v3-nickname-submit",
  v3Payment: "/v3-payment",
  v3TosspaymentsSuccess: "/v3-tosspayments/success",
  v3Completed: "/v3-completed",

  v5Onboarding: "/v5-onboarding/:type/:id",
  v5Product: "/v5-product",
  v5TosspaymentsSuccess: "/v5-tosspayments/success",
  v5Completed: "/v5-completed",
};
